module.exports = __webpack_public_path__ + "img/qbert_questions_p10.ce4757f6.jpg";